import {
  StateMachineProvider,
  StateMachineStepView as UploadAdditionalDocumentsView
} from "../context/stateMachine/StateMachineV2"
import { uploadAdditionalDocumentsSection } from "./workflow/step-library"
import React, { useState } from "react"
import EmployeeOnlyModalContainer from "../employee-only-containers/EmployeeOnlyModalContainer"
import { Box, CloseIcon, Dialog, DialogContent, IconButton, Progress } from "@carrotfertility/carotene-core"
import { useIntl } from "react-intl"
import { FileTypes } from "../get-reimbursed/steps/UploadFile"
import { ExistingPreAuth, useExistingPreAuth } from "#/components/carrot-card-cost-share/state/useExistingPreAuth"

type UploadAdditionalDocumentsProps = {
  expenseId: number
  isOpen: boolean
  onExit: () => void
}

type UploadAdditionalDocumentsContextProps = {
  expenseId?: number
  files?: FileTypes
  setFiles?: (attachments: FileTypes) => void
  existingPreAuth?: ExistingPreAuth
  showPreAuthInfo?: boolean
}

export const UploadAdditionalDocumentsContext = React.createContext<UploadAdditionalDocumentsContextProps>({})
export const UploadAdditionalDocumentsFlow = ({ expenseId, isOpen, onExit }: UploadAdditionalDocumentsProps) => {
  const intl = useIntl()
  const [files, setFiles] = useState([])
  const existingPreAuth = useExistingPreAuth()
  const context = {
    expenseId: expenseId,
    files: files,
    setFiles: setFiles,
    // We can safely assume there will only be one active pre-auth
    existingPreAuth: existingPreAuth?.data?.preAuths[0],
    showPreAuthInfo: existingPreAuth?.data?.preAuths[0]?.expenseId === expenseId
  }

  return existingPreAuth?.isLoading ? (
    <Box display="flex" justifyContent="center" alignItems="center" height="100%">
      <Progress />
    </Box>
  ) : (
    <UploadAdditionalDocumentsContext.Provider value={context}>
      <StateMachineProvider
        initialSection="UploadAdditionalDocumentsSection"
        stateMachineDescription={[uploadAdditionalDocumentsSection]}
        onComplete={() => {}}
      >
        <EmployeeOnlyModalContainer onClose={onExit}>
          <Dialog open={isOpen} onClose={onExit}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end"
              }}
            >
              <IconButton aria-label={intl.formatMessage({ defaultMessage: "close" })} onClick={onExit}>
                <CloseIcon />
              </IconButton>
            </Box>
            <DialogContent>
              <UploadAdditionalDocumentsView />
            </DialogContent>
          </Dialog>
        </EmployeeOnlyModalContainer>
      </StateMachineProvider>
    </UploadAdditionalDocumentsContext.Provider>
  )
}
